export const NavBarItemConfig = [
  {
    title: 'home',
    img: 'home',
  },
  {
    title: 'about',
    img: 'id-card',
  },
  {
    title: 'skills',
    img: 'skills',
  },
  {
    title: 'portfolio',
    img: 'briefcase',
  },
  {
    title: 'education',
    img: 'graduation',
  },
  {
    title: 'hire me',
    img: 'contact-us',
  },
];

export default NavBarItemConfig;
